(function () {
  // Adjust grid selector to your theme's product grid wrapper if different
  const GRID_SELECTOR = '.product-grid, .collection__grid, .collection-products';

  // Filter container selectors (where your popup or facet UI lives)
  const FILTER_CONTAINER_SELECTOR = '.filter-popup, .mobile-facets__details, .facets__form, .facets, .collection-filters, .filters';

  // Small helper: returns true if node is inside a filter area
  function insideFilterArea(node) {
    if (!node) return false;
    return !!node.closest(FILTER_CONTAINER_SELECTOR);
  }

  // Single entry point to handle filter toggles (reused by both click & change handlers)
  let lastRequestId = 0;
  let activeController = null;

  function handleFilterAction(element) {
    // element may be a button, a, or an input. We support:
    // - data-filter-name & data-filter-value attributes (recommended)
    // - data-filter="key=value" (legacy fallback) — handled below
    let fname = element.getAttribute('data-filter-name');
    let fval  = element.getAttribute('data-filter-value');
    const fsort = element.getAttribute('data-sort'); // optional single sort key

    // fallback for older data-filter="key=value" usage
    if (!fname && element.hasAttribute('data-filter')) {
      const raw = element.getAttribute('data-filter') || '';
      const idx = raw.indexOf('=');
      if (idx !== -1) {
        fname = raw.slice(0, idx).trim();
        // rawVal may contain '+' for spaces; use replace to handle + => space then decode
        let rawVal = raw.slice(idx + 1).replace(/\+/g, ' ');
        try { rawVal = decodeURIComponent(rawVal); } catch (err) { /* ignore */ }
        fval = rawVal;
      }
    }

    if (!fname && !fsort) return; // nothing to do

    // Build working URL based on current location
    const url = new URL(window.location.href);

    // handle sort toggle (single)
    if (fsort) {
      const currentSort = url.searchParams.get('sort_by');
      if (currentSort === fsort) url.searchParams.delete('sort_by');
      else url.searchParams.set('sort_by', fsort);
    }

    // handle filter toggle (supports multi-values per filter)
    if (fname && typeof fval !== 'undefined') {
      // url.searchParams.getAll returns decoded values
      const current = url.searchParams.getAll(fname);
      const exists = current.indexOf(fval) !== -1;

      // remove existing param keys (we rebuild below)
      url.searchParams.delete(fname);

      if (!exists) {
        // re-add previous values and append this one
        current.forEach(v => url.searchParams.append(fname, v));
        url.searchParams.append(fname, fval);
      } else {
        // remove clicked value; re-add the rest
        current.forEach(v => { if (v !== fval) url.searchParams.append(fname, v); });
      }
    }

    // DEBUG: inspect final URL in console
    console.log('AJAX filter URL ->', url.toString());

    // Race control: increment request id and abort previous fetch
    const myRequestId = ++lastRequestId;
    if (activeController) {
      try { activeController.abort(); } catch (e) {}
    }
    activeController = new AbortController();

    fetch(url.toString(), {
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      signal: activeController.signal
    }).then(r => r.text()).then(html => {
      // If a newer request has started since this one, ignore this response
      if (myRequestId !== lastRequestId) return;

      const doc = new DOMParser().parseFromString(html, 'text/html');
      const newGrid = doc.querySelector(GRID_SELECTOR);
      const curGrid = document.querySelector(GRID_SELECTOR);

      if (newGrid && curGrid) {
        curGrid.innerHTML = newGrid.innerHTML;
        // update URL shown in browser
        window.history.pushState({}, '', url.toString());
        updateActiveStates(url);
      } else {
        // fallback: full page redirect if we can't find grid
        console.warn('Grid not found — full redirect to:', url.toString());
        window.location.href = url.toString();
      }
    }).catch(err => {
      if (err.name === 'AbortError') {
        // expected when aborting previous fetch; ignore
        return;
      }
      console.error('Filter AJAX error:', err);
      // fallback: full navigate to URL
      window.location.href = url.toString();
    });
  }

  // Update active css states for buttons/links based on URL params
  function updateActiveStates(url) {
    const params = url.searchParams;
    document.querySelectorAll('.filter-tag, .filter-tags button, .filter-tags a, .filter-tags input, .filter-tags label').forEach(b => {
      b.classList.remove('active');
      let name = b.getAttribute('data-filter-name') || b.getAttribute('name');
      let value = b.getAttribute('data-filter-value') || b.getAttribute('value');

      if (!name && b.hasAttribute('data-filter')) {
        const raw = b.getAttribute('data-filter') || '';
        const idx = raw.indexOf('=');
        if (idx !== -1) {
          name = raw.slice(0, idx).trim();
          value = raw.slice(idx + 1).replace(/\+/g, ' ');
          try { value = decodeURIComponent(value); } catch (err) {}
        }
      }
      // support both `data-filter-name`/`data-filter-value` and legacy `data-filter` (not ideal)
      if (name && value) {
        // If name is of form "key=value" (legacy), normalize to key
        let key = name;
        if (typeof key === 'string' && key.indexOf('=') !== -1) key = key.split('=')[0];

        const vals = params.getAll(name).map(v => v.trim().toLowerCase());
        if (vals.includes(value.trim().toLowerCase())) {
          b.classList.add('active');
        }

      }
      const sort = b.getAttribute('data-sort');
      if (sort && params.get('sort_by') === sort) b.classList.add('active');
    });
  }

  // --- Capture-phase listeners: intercept before other scripts and forms ---
  // Click capture: intercept clicks inside filter areas
  document.addEventListener('click', function (e) {
    // if not inside filter area, don't interfere
    if (!insideFilterArea(e.target)) return;

    // find clickable filter element (button, a, or element with data-filter attributes)
    const el = e.target.closest('[data-filter-name], [data-filter], [data-filter-value], .filter-tag, .filter-tags button, .filter-tags a');
    if (!el) return;

    // Prevent other handlers (and native navigation/form submits)
    e.preventDefault();
    // stopImmediatePropagation to block other handlers on same element
    try { e.stopImmediatePropagation(); } catch (err) {}
    // Now handle with our AJAX
    handleFilterAction(el);
  }, true); // capture = true

  // Change capture: handle checkboxes / inputs inside filter area
  document.addEventListener('change', function (e) {
    if (!insideFilterArea(e.target)) return;
    // prevent native form handlers
    e.preventDefault();
    try { e.stopImmediatePropagation(); } catch (err) {}
    // If the changed element itself is a filter (has attributes), handle it
    const el = e.target.closest('[data-filter-name], [data-filter]');
    if (el) handleFilterAction(el);
  }, true);

  // Submit capture: prevent facet forms from submitting
  document.addEventListener('submit', function (e) {
    if (!insideFilterArea(e.target)) return;
    e.preventDefault();
    try { e.stopImmediatePropagation(); } catch (err) {}
    // no default submit
    return false;
  }, true);

  // OPTIONAL: also prevent native clicks on <a href="?..."> inside filter area (capture)
  document.addEventListener('click', function(e) {
    if (!insideFilterArea(e.target)) return;
    const a = e.target.closest('a[href]');
    if (!a) return;
    // If the anchor's href contains a filter param like "filter." or is just "?"
    const href = a.getAttribute('href') || '';
    if (href.indexOf('filter.') !== -1 || href.indexOf('?') === 0) {
      e.preventDefault();
      try { e.stopImmediatePropagation(); } catch (err) {}
      // We rely on data-filter attributes to handle the action instead
    }
  }, true);

  // init: mark active states from URL on page load
  document.addEventListener('DOMContentLoaded', function () {
    updateActiveStates(new URL(window.location.href));
  });

  // handle popstate (back/forward)
  window.addEventListener('popstate', function () {
    // fetch and replace grid to match URL (optional: you can just reload)
    const url = new URL(window.location.href);
    // small fetch (no need to manage abort here)
    fetch(url.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(r => r.text())
      .then(html => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newGrid = doc.querySelector(GRID_SELECTOR);
        const curGrid = document.querySelector(GRID_SELECTOR);
        if (newGrid && curGrid) curGrid.innerHTML = newGrid.innerHTML;
        updateActiveStates(url);
      })
      .catch(() => { /* ignore */ });
  });
})();
